/* Scale-service measurement. Two events the theme did not have, and nothing else:
 *
 *   bt_scale_product_view         once per page view, on a page that renders the upsell
 *   bt_scale_service_impression   once per page view, when the upsell is at least half visible
 *
 * CTA clicks are NOT handled here: the attribution snippet already pushes bt_cta_click for every
 * a.bt-btn, and reads the data-bt-* attributes on the link, so a second click event would only
 * double-count. Completed forms are NOT handled here either: bt_lead_submitted already fires on a
 * delivered lead, and the lead-events snippet adds the scale context to it.
 *
 * Consent is Shopify's, mirrored on window.btConsent by the analytics snippet. Nothing is pushed
 * until it says ready, production, and analytics OR marketing. Nothing here reads, stores or sends
 * a cookie, a name, an email or a phone number: the payload is product id, manufacturer, model,
 * class, path and a fixed source label. The path is location.pathname, never the query string. */
(function () {
  'use strict';

  var root = document.querySelector('[data-bt-scale-service]');
  if (!root) { return; }

  var sent = { view: false, impression: false };
  var visible = false;

  function measurable() {
    var c = window.btConsent;
    return !!(c && c.ready && c.production && (c.analytics || c.marketing));
  }

  function payload(name) {
    return {
      event: name,
      bt_product_id: root.getAttribute('data-bt-product-id') || '',
      bt_manufacturer: root.getAttribute('data-bt-manufacturer') || '',
      bt_model: root.getAttribute('data-bt-model') || '',
      bt_scale_class: root.getAttribute('data-bt-scale-class') || '',
      bt_inquiry_source: root.getAttribute('data-bt-inquiry-source') || '',
      bt_page_path: location.pathname
    };
  }

  function push(name, key) {
    if (sent[key] || !measurable()) { return; }
    sent[key] = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload(name));
  }

  function flush() {
    push('bt_scale_product_view', 'view');
    if (visible) { push('bt_scale_service_impression', 'impression'); }
  }

  if (typeof window.IntersectionObserver === 'function') {
    var observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          visible = true;
          flush();
          observer.disconnect();
        }
      });
    }, { threshold: 0.5 });
    observer.observe(root);
  } else {
    visible = true;
  }

  document.addEventListener('bt:consent', flush);
  flush();
})();
